// extracted by mini-css-extract-plugin
module.exports = {"Circle":"preloader_Circle__2UmcU","lds-ring":"preloader_lds-ring__1MNA1"};